import { Language } from 'ha/i18n/types';

export const STATE_NAME = 'hermes';

export const ContentfulSupportedLangs: Language[] = [
  Language.en,
  Language.fr,
  Language.de,
  Language.es,
  Language.it,
  Language.nl,
];
